/** Имя элемента модели и команды: нужны и плагину, и вызывающей стороне. */
export const PLACEHOLDER_CHIP_MODEL = "placeholderChip";

export const INSERT_PLACEHOLDER_CHIP = "insertPlaceholderChip";
